(function () {

    'use strict';

    angular
        .module('app.core')
        .service('LoggerApi', [
            'API_CONFIG',
            '$http','deviceDetector',
            LoggerService
        ]);

    function LoggerService(API_CONFIG, $http,deviceDetector) {
        var service = this;
        service.data = deviceDetector;
        service.allData = JSON.stringify(service.data, null, 2);

        service.applicationEvent = applicationEvent;
        service.applicationEventStart = applicationEventStart;
        service.applicationEventStop = applicationEventStop;
        service.applicationEventAddEvent = applicationEventAddEvent;

        ///////////// com.openlane.logger.applicationEvent /////////////////////////////////////
        /*
         paramValuesLogType: the type to log the data in application event detail(nullable).
         1:      log the params in URL ONLY
         2:      log the fields in Form ONLY
         3:      log both
         null:   log the fields in Form ONLY
         others: log none of above
         formIdOrName:       form id or name used to get all of the data in the form
         extraParams:        extraParams to be passed. format: p1=v1&p2=v2&p3=v3
         logFields:          indicate what fields in extraParams,form OR URL will be log in application event details.
         "*" - for all.
         "?" - system selected fields: VIN,SELLER_ORG_ID
         pageName:           Page Name to be saved to application event (nullable).
         null - the pathname of the top url will be saved as pageName
         uuid:				the UUID will be saved into application_events_details to link all ajax calls together on a page
         */


        function applicationEvent(paramValuesLogType, formIdOrName, extraParams, logFields, pageName, subPageName, uuid) {
            this.privateLabelId = API_CONFIG.PRIVATE_LABEL_ID;
            this.uuid = isUndefinedOrNull(uuid) ? "" : uuid ;

            this.subPageName = isUndefinedOrNull(subPageName) ? "" : subPageName;
            // get pageName
            if (isUndefinedOrNull(pageName)) {
                if (typeof com.openlane.logger._pageName != 'undefined' && com.openlane.logger._pageName != '')
                    this.pageName = com.openlane.logger._pageName;
                else {
                    var topLocationPathName = "";
                    try {
                        topLocationPathName = self.location.pathname;
                    } catch (err) {
                    }
                    this.pageName = topLocationPathName;
                }
            } else {
                this.pageName = pageName;
            }
            if (this.subPageName != '') {
                this.pageName = this.pageName + "(" + this.subPageName + ")";
            }

            this.startTime = -1;
            this.executionTime = 0;
            this.applicationLogStarted = false;
            this.extraParams = "";
            this.formObj = null;
            this.logFields = (isUndefinedOrNull(logFields) || logFields == "") ? "*" : logFields;
            this.paramValuesLogType = isUndefinedOrNull(paramValuesLogType) ? 2 : paramValuesLogType;
            if (!isUndefinedOrNull(formIdOrName)) {
                if (!isUndefinedOrNull(document.getElementById(formIdOrName))) {
                    this.formObj = document.getElementById(formIdOrName);
                } else if (!isUndefinedOrNull(document[formIdOrName])) {
                    this.formObj = document[formIdOrName];
                }
            }
            if (this.formObj == null && document.forms && document.forms.length && document.forms.length > 0) {
                this.formObj = document.forms[0];
            }
            if (!isUndefinedOrNull(extraParams) && extraParams != "") {
                this.extraParams = "&" + extraParams;
            }
            if ((this.paramValuesLogType == 1 || this.paramValuesLogType == 3) && !isUndefinedOrNull(this.topURLParams) && this.topURLParams != '') {
                this.extraParams = this.extraParams + "&" + this.topURLParams;
            }
            if (this.uuid != '') {
                this.extraParams = this.extraParams + "&uuid=" + this.uuid;
            }
            this.addedParams = "";
        }

        function applicationEventAddEvent(key, value) {
            this.addedParams = this.addedParams + "," + '"' + key + '"' + ':' + '"' + value + '"';

        }

        function applicationEventStart() {
            this.executionTime = 0;

            this.startTime = (new Date()).getTime();
            this.applicationLogStarted = true;
        }

        function applicationEventStop() {
            if (this.applicationLogStarted && API_CONFIG.LOGGER_ENABLED === "true") {
                this.applicationLogStarted = false;
                this.executionTime = (new Date()).getTime() - this.startTime;

                var data;

                var url = API_CONFIG.endpoints.LOGGER_API;

                if(this.pageName != ''){

                    if(service.data.device == 'unknown'){
                        service.data.device = 'Desktop';
                    }

                    if (this.addedParams != '') {
                        data = '{"deviceInfo": {"device": "' + service.data.device + '","osVersion": "' + service.data.os + '","applicationId": "PUBLIC_AUCTION_CA"},"applicationEvents": [{"plId": "' + this.privateLabelId + '","eventName": "PUBLIC_AUCTION_CA","execTime": "' + this.executionTime + '","details": {"UUID": "' + this.uuid + '","loaded":"' + this.pageName + '"' + this.addedParams + '}}]}';
                    } else {
                        //data without eventClicked
                        data = '{"deviceInfo": {"device": "' + service.data.device + '","osVersion": "' + service.data.os + '","applicationId": "PUBLIC_AUCTION_CA"},"applicationEvents": [{"plId": "' + this.privateLabelId + '","eventName": "PUBLIC_AUCTION_CA","execTime": "' + this.executionTime + '","details": {"UUID": "' + this.uuid + '","loaded":"' + this.pageName + '"}}]}';
                    }
                }


                $http({
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'applicationKey': '000000-0120-0027',
                        'Accept-Language': 'en-us'
                    },
                    url: url,
                    method: 'POST',
                    data: data
                });

            } else {
                // alert("please call start first.");
            }
        }
    }

})();


// WEBPACK FOOTER //
// ./app/core/service/LoggerService.js